import { IBaseEntityType, ObjectId } from '@shared/types';

interface IProduct extends IBaseEntityType {
  company_id: string;
  effective_date: string;
  entity_id: string;
  is_active: boolean;
  item_type: string;
  mappings: Mapping[];
  name: string;
  prices: IProductPrice[];
  product_tag_entity_ids: ObjectId[];
  product_type: string;
  site_id: string;
  _id: string;
}

interface Mapping {
  company_id: ObjectId;
  document_id: string;
  effective_date: string;
  entity_id: ObjectId;
  is_active: boolean;
  site_id: ObjectId;
  _id: ObjectId;
}

interface IProductPrice extends IBaseEntityType {
  type: EBasePriceTypes;
  product_entity_id: ObjectId;
  unit_price: number;
  entity_id: ObjectId;
  _id: ObjectId;
  site_id: ObjectId;
}

enum EBasePriceTypes {
  STANDARD = 'standard',
  PRICE_POINT = 'price-point',
  CONDITIONAL = 'conditional',
  CHILD_PRICES = 'child',
  CHILD_QUANTITY_BASE = 'child_quantity_base',
}

interface IProductMap {
  parent_product_name?: string;
  parent_product_price?: string | number;
  parent_product_id?: string;
  pricesMap?: {
    [siteId: string]: number;
  };
}

enum EPRODUCT_TYPES {
  STANDARD = 'standard',
  MODIFIER = 'modifier',
  COMMENT = 'comment',
  PLACEHOLDER = 'placeholder',
  MODIFIER_PLACEHOLDER = 'modifier_placeholder',
  GIFT_CARD = 'gift_card',
  GIFT_CERTIFICATE = 'gift_certificate',
  FEE = 'fee',
  RETAIL_ITEM = 'retail_item',
  DONATION = 'donation',
  ENTITLEMENT = 'entitlement',
}

export {
  IProduct,
  IProductMap,
  IProductPrice,
  EBasePriceTypes,
  EPRODUCT_TYPES,
};
